import * as React from "react";
import { Button } from "semantic-ui-react";

interface Props {
    customerId: string;
    employeeRecordId: string;
    ohCaseId: string;
    consultationTaskId: string;
}

export const ViewMHPTreatmentConsultationButton: React.FunctionComponent<Props> = (props: Props) => {
    if (!props.customerId || !props.employeeRecordId || !props.ohCaseId || !props.consultationTaskId) {
        return null;
    }

    return (
        <a
            href={`/customers/${props.customerId}/employeeRecords/${props.employeeRecordId}`
                + `/ohCases/${props.ohCaseId}/${props.consultationTaskId}`
                + "/mhpTreatmentConsultation/"}
            target="_blank"
            rel="noopener noreferrer"
        >
            <Button type="button" content="View Clinical Notes" />
        </a>
    );
};
